// THE ONE PLACE THE PORTAL LOADS STRIPE.JS (blhWebServer docs/adr/0028 §2).
//
// The server's answers that hand the portal a publishable key also hand it the
// clinic's connected account on Brightlight's platform (`stripeAccount`), or
// null for a clinic on its own keys. A card is confirmed with Stripe.js loaded
// for that account, so it is made on the account the server charges.
//
// One Stripe.js instance per key and account, kept for the page's life.

import { loadStripe, type Stripe } from "@stripe/stripe-js";

const PUBLISHABLE_KEY = /^pk_(live|test)_[A-Za-z0-9_]+$/;
const ACCOUNT_ID = /^acct_[A-Za-z0-9]+$/;

const instances = new Map<string, Promise<Stripe | null>>();

/** Stripe.js for a key and, when the clinic has one, its connected account; null without a key. */
export function loadStripeFor(
  config: { publishableKey?: string | null; stripeAccount?: string | null } | null | undefined
): Promise<Stripe | null> | null {
  const publishableKey = config?.publishableKey || "";
  if (!PUBLISHABLE_KEY.test(publishableKey)) return null;
  const stripeAccount = config?.stripeAccount && ACCOUNT_ID.test(config.stripeAccount) ? config.stripeAccount : null;
  const key = `${publishableKey}|${stripeAccount || ""}`;
  let instance = instances.get(key);
  if (!instance) {
    instance = loadStripe(publishableKey, stripeAccount ? { stripeAccount } : undefined);
    instances.set(key, instance);
  }
  return instance;
}
